<template>
  <div class="nav-header">
    <div class="nav-container">
      <!-- 桌面端Logo区域 -->
      <div class="desktop-left-section" v-if="!isMobile">
        <div class="desktop-logo" @click="$router.push('/')">
          <img src="@/assets/logo.jpg" alt="映雪笃学园" class="logo-img" />
          <span class="brand-name">赣州市前沿科教设备有限公司</span>
          <span class="logo-subtitle">科教装备·资源平台</span>
        </div>
      </div>

      <!-- 桌面端导航菜单（科普拓展改为自定义下拉） -->
      <div v-if="!isMobile" class="desktop-nav">
        <div
          class="nav-item-custom"
          :class="{ 'is-active': activeIndex === '/' }"
          @click="handleSelect('/')"
        >
          <i class="el-icon-s-home"></i>首页
        </div>
        <div
          class="nav-item-custom"
          :class="{ 'is-active': activeIndex === '/resource' }"
          @click="handleSelect(isAuthenticated ? '/resource' : '/login')"
        >
          <i class="el-icon-folder-opened"></i>资源中心
        </div>
        <div
          class="nav-item-custom"
          :class="{ 'is-active': activeIndex === '/products' }"
          @click="handleSelect('/products')"
        >
          <i class="el-icon-goods"></i>科教器材
        </div>
        <div
          class="nav-item-custom"
          :class="{ 'is-active': activeIndex === '/about' }"
          @click="handleSelect('/about')"
        >
          <i class="el-icon-office-building"></i>公司简介
        </div>
        <div
          class="nav-item-custom"
          :class="{ 'is-active': activeIndex === '/news' }"
          @click="handleSelect('/news')"
        >
          <i class="el-icon-chat-line-round"></i>新闻动态
        </div>

        <!-- 科普拓展自定义下拉 -->
        <div class="science-wrapper" ref="scienceWrapper">
          <div
            class="nav-item-custom science-trigger"
            :class="{ 'is-active': isScienceActive }"
            @click.stop="toggleScienceDropdown"
          >
            <i class="el-icon-trophy"></i>科普拓展
            <i
              class="el-icon-arrow-down el-icon--right drop-arrow"
              :class="{ 'rotate-up': scienceDropdownVisible }"
            ></i>
          </div>
          <div
            v-if="scienceDropdownVisible"
            class="custom-dropdown science-dropdown"
            :style="scienceDropdownStyle"
          >
            <div class="custom-dropdown-item" @click="goToScience('/science-extension/index')">
              首页
            </div>
            <div class="custom-dropdown-item" @click="goToScience('/science-extension/competition')">
              科学竞赛
            </div>
            <div class="custom-dropdown-item" @click="goToScience('/science-extension/article')">
              科普文章
            </div>
            <div class="custom-dropdown-item" @click="goToScience('/science-extension/video')">
              科普视频
            </div>
            <div class="custom-dropdown-item" @click="goToScience('/science-extension/qa')">
              互动问答
            </div>
            <div class="custom-dropdown-item" @click="goToScience('/science-extension/activity')">
              活动专区
            </div>
          </div>
        </div>
      </div>

      <!-- 桌面端用户功能区（自定义下拉） -->
      <div v-if="!isMobile" class="desktop-right-section">
        <template v-if="isAuthenticated">
          <div class="user-info-wrapper" ref="desktopUserWrapper">
            <div class="user-info" @click.stop="toggleDesktopDropdown">
              <!-- 未读反馈提醒：普通用户=未读回复数，管理员=待处理反馈数 -->
              <el-badge
                :value="unreadCount"
                :max="99"
                :hidden="unreadCount <= 0"
                :offset="[-4, 4]"
                class="user-badge"
              >
                <el-avatar :size="36" :src="userAvatar" class="user-avatar"></el-avatar>
              </el-badge>
              <div class="user-details">
                <span class="user-name">{{ userName }}</span>
                <span class="user-role" v-if="$store.state.user.info.is_superuser">超级管理员</span>
                <span class="user-role" v-else-if="$store.state.user.info.is_staff">普通管理员</span>
                <span class="user-role" v-else>普通会员</span>
              </div>
              <i class="el-icon-arrow-down el-icon--right" :class="{ 'rotate-up': desktopDropdownVisible }"></i>
            </div>

            <!-- 自定义下拉菜单 -->
            <div v-if="desktopDropdownVisible" class="custom-dropdown desktop-dropdown" :style="desktopDropdownStyle">
              <div class="custom-dropdown-item" @click="goTo('/own')">
                <i class="el-icon-user"></i> 个人中心
              </div>
              <div class="custom-dropdown-item" @click="goTo('/history')">
                <i class="el-icon-time"></i> 浏览历史
              </div>
              <div class="custom-dropdown-item" @click="goTo('/my-authorizations')">
                <i class="el-icon-key"></i> 我的授权
              </div>
              <div class="custom-dropdown-item" @click="goTo('/user/activities')">
                <i class="el-icon-s-order"></i> 我的报名
              </div>
              <div class="custom-dropdown-item" @click="goTo('/feedback')">
                <i class="el-icon-chat-dot-square"></i> 意见反馈
                <span v-if="!unreadIsAdmin && unreadCount > 0" class="menu-count">{{ unreadText }}</span>
              </div>
              <!-- 管理员：直达反馈管理，并显示待处理条数 -->
              <div
                v-if="$store.state.user.info.is_superuser"
                class="custom-dropdown-item admin-entry"
                @click="goTo('/manage/feedback-list')"
              >
                <i class="el-icon-bell"></i> 反馈管理
                <span v-if="unreadCount > 0" class="menu-count">{{ unreadText }}</span>
              </div>
              <!-- 管理员入口：区分前端管理后台 与 Django 原生后台 -->
              <div class="custom-dropdown-item admin-entry" @click="goTo('/manage')" v-if="$store.state.user.info.is_staff">
                <i class="el-icon-s-platform"></i> 管理后台
              </div>
              <div class="custom-dropdown-item admin-entry" @click="openDjangoAdmin" v-if="$store.state.user.info.is_staff">
                <i class="el-icon-setting"></i> Django 后台
              </div>
              <div class="custom-dropdown-divider"></div>
              <div class="custom-dropdown-item logout-item" @click="handleLogout">
                <i class="el-icon-switch-button"></i> 退出登录
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <el-button type="text" class="login-btn" @click="$router.push('/login')">
            登录
          </el-button>
          <el-button
            type="primary"
            size="small"
            class="register-btn"
            @click="$router.push('/login?register=true')"
          >
            免费注册
          </el-button>
        </template>
      </div>

      <!-- 移动端导航栏 -->
      <div v-else class="mobile-nav">
        <!-- 移动端Logo -->
        <div class="mobile-logo" @click="$router.push('/')">
          <img src="@/assets/logo.jpg" alt="映雪笃学园" class="mobile-logo-img" />
          <span>赣州市前沿科教设备有限公司</span>
        </div>

        <div class="mobile-actions">
          <!-- 移动端用户下拉（自定义） -->
          <template v-if="isAuthenticated">
            <div class="mobile-user-wrapper" ref="mobileUserWrapper">
              <div class="mobile-user-trigger" @click.stop="toggleMobileDropdown">
                <el-badge
                  :value="unreadCount"
                  :max="99"
                  :hidden="unreadCount <= 0"
                  :offset="[-2, 2]"
                  class="user-badge"
                >
                  <el-avatar :size="32" :src="userAvatar" class="mobile-avatar"></el-avatar>
                </el-badge>
                <i class="el-icon-arrow-down mobile-drop-arrow" :class="{ 'rotate-up': mobileDropdownVisible }"></i>
              </div>
              <!-- 移动端自定义下拉菜单 -->
              <div v-if="mobileDropdownVisible" class="custom-dropdown mobile-dropdown" :style="mobileDropdownStyle">
                <div class="custom-dropdown-item" @click="goTo('/own')">
                  <i class="el-icon-user"></i> 个人中心
                </div>
                <div class="custom-dropdown-item" @click="goTo('/history')">
                  <i class="el-icon-time"></i> 浏览历史
                </div>
                <div class="custom-dropdown-item" @click="goTo('/my-authorizations')">
                  <i class="el-icon-key"></i> 我的授权
                </div>
                <div class="custom-dropdown-item" @click="goTo('/user/activities')">
                  <i class="el-icon-s-order"></i> 我的报名
                </div>
                <div class="custom-dropdown-item" @click="goTo('/feedback')">
                  <i class="el-icon-chat-dot-square"></i> 意见反馈
                  <span v-if="!unreadIsAdmin && unreadCount > 0" class="menu-count">{{ unreadText }}</span>
                </div>
                <!-- 管理员：直达反馈管理，并显示待处理条数 -->
                <div
                  v-if="$store.state.user.info.is_superuser"
                  class="custom-dropdown-item admin-entry"
                  @click="goTo('/manage/feedback-list')"
                >
                  <i class="el-icon-bell"></i> 反馈管理
                  <span v-if="unreadCount > 0" class="menu-count">{{ unreadText }}</span>
                </div>
                <!-- 管理员入口：区分前端管理后台 与 Django 原生后台 -->
                <div class="custom-dropdown-item admin-entry" @click="goTo('/manage')" v-if="$store.state.user.info.is_staff">
                  <i class="el-icon-s-platform"></i> 管理后台
                </div>
                <div class="custom-dropdown-item admin-entry" @click="openDjangoAdmin" v-if="$store.state.user.info.is_staff">
                  <i class="el-icon-setting"></i> Django 后台
                </div>
                <div class="custom-dropdown-divider"></div>
                <div class="custom-dropdown-item logout-item" @click="handleLogout">
                  <i class="el-icon-switch-button"></i> 退出登录
                </div>
              </div>
            </div>
          </template>

          <!-- 汉堡菜单按钮 -->
          <div
            class="hamburger-menu"
            :class="{ active: showMobileNav }"
            @click="showMobileNav = !showMobileNav"
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端抽屉导航 -->
    <transition name="nav-slide">
      <div v-if="isMobile && showMobileNav" class="mobile-nav-drawer">
        <div class="nav-overlay" @click="showMobileNav = false"></div>
        <div class="nav-content">
          <!-- 用户信息区域 -->
          <div v-if="isAuthenticated" class="mobile-user-info" @click="$router.push('/own')">
            <el-badge
              :value="unreadCount"
              :max="99"
              :hidden="unreadCount <= 0"
              :offset="[-6, 6]"
              class="user-badge"
            >
              <el-avatar :size="56" :src="userAvatar" class="user-avatar-large"></el-avatar>
            </el-badge>
            <div class="user-details">
              <h3>{{ userName }}</h3>
              <p>
                <span class="user-role-tag" v-if="$store.state.user.info.is_superuser">超级管理员</span>
                <span class="user-role-tag" v-else-if="$store.state.user.info.is_staff">普通管理员</span>
                <span class="user-role-tag" v-else>普通会员</span>
              </p>
            </div>
            <i class="el-icon-arrow-right arrow-icon"></i>
          </div>
          <div v-else class="mobile-login-prompt">
            <p>登录后体验完整功能</p>
            <div class="login-buttons">
              <el-button type="text" class="mobile-login-btn" @click="$router.push('/login')">
                登录
              </el-button>
              <el-button type="primary" size="small" @click="$router.push('/login?register=true')">
                注册
              </el-button>
            </div>
          </div>

          <!-- 导航列表 -->
          <div class="nav-list">
            <div
              v-for="item in navItems"
              :key="item.path"
              class="nav-item"
              :class="{ active: isNavItemActive(item) }"
              @click="goToPage(item)"
            >
              <div class="nav-item-icon"><i :class="item.icon"></i></div>
              <span class="nav-item-title">{{ item.title }}</span>
              <i v-if="isNavItemActive(item)" class="el-icon-check active-check"></i>
            </div>
          </div>

          <!-- 辅助功能 -->
          <div class="feature-list">
            <div class="nav-item" @click="$router.push('/user/settings')">
              <div class="nav-item-icon"><i class="el-icon-setting"></i></div>
              <span class="nav-item-title">设置</span>
            </div>
            <div class="nav-item" @click="$router.push('/help')">
              <div class="nav-item-icon"><i class="el-icon-question"></i></div>
              <span class="nav-item-title">帮助与反馈</span>
            </div>
          </div>

          <!-- 退出登录 -->
          <div v-if="isAuthenticated" class="logout-btn" @click="handleLogout">
            <i class="el-icon-switch-button"></i>
            <span>退出登录</span>
          </div>

          <div class="nav-footer">
            <p>© 2026 赣州市前沿科教设备有限公司</p>
            <p class="version">版本 1.0.0</p>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { getUrl } from '@/utils/url';

export default {
  name: 'NavHeader',
  data() {
    return {
      activeIndex: '/',
      showMobileNav: false,
      isMobile: false,
      navItems: [
        { path: '/', title: '首页', icon: 'el-icon-s-home' },
        { path: '/resource', title: '资源中心', icon: 'el-icon-folder-opened' },
        { path: '/products', title: '科教器材', icon: 'el-icon-goods' },
        { path: '/about', title: '公司简介', icon: 'el-icon-office-building' },
        { path: '/news', title: '新闻动态', icon: 'el-icon-chat-line-round' },
        { path: '/science-extension', title: '科普拓展', icon: 'el-icon-trophy' },
      ],
      // 用户下拉状态
      desktopDropdownVisible: false,
      mobileDropdownVisible: false,
      desktopDropdownStyle: { top: '0px', left: '0px' },
      mobileDropdownStyle: { top: '0px', right: '0px' },
      // 科普拓展下拉状态
      scienceDropdownVisible: false,
      scienceDropdownStyle: { top: '0px', left: '0px' },
      // 未读反馈轮询定时器（只做清理用，不参与渲染）
      unreadTimer: null
    };
  },
  computed: {
    isAuthenticated() {
      return !!localStorage.getItem('token');
    },
    userAvatar() {
      return getUrl(this.$store.state.user.info.head_img);
    },
    userName() {
      return (this.$store.state.user && this.$store.state.user.info && this.$store.state.user.info.first_name) || '用户';
    },
    isScienceActive() {
      return this.activeIndex.startsWith('/science-extension');
    },
    // ---------- 未读反馈提醒 ----------
    // 普通用户：管理员已回复但本人还没看过的条数
    // 管理员：待处理（pending）反馈总条数
    unreadCount() {
      return (this.$store.state.notify && this.$store.state.notify.unread) || 0;
    },
    unreadIsAdmin() {
      return !!(this.$store.state.notify && this.$store.state.notify.isAdmin);
    },
    unreadText() {
      return this.unreadCount > 99 ? '99+' : String(this.unreadCount);
    }
  },
  watch: {
    $route(to) {
      this.activeIndex = to.path;
      this.showMobileNav = false;
      this.closeAllDropdowns();
      // 换页顺手刷一次未读（例如刚从反馈页看过回复）
      this.refreshUnread();
    }
  },
  mounted() {
    this.checkMobile();
    this.activeIndex = this.$route.path;
    window.addEventListener('resize', this.checkMobile);
    document.addEventListener('click', this.handleGlobalClick);
    // 未读反馈提醒：进站先拉一次，之后定时轮询
    this.refreshUnread();
    this.startUnreadTimer();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
    document.removeEventListener('click', this.handleGlobalClick);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.stopUnreadTimer();
  },
  methods: {
    handleSelect(index) {
      this.$router.push(index);
    },
    handleLogout() {
      localStorage.removeItem('token');
      localStorage.removeItem('avatar');
      if (this.$store && this.$store.commit) {
        this.$store.commit('LOGOUT');
      }
      this.$router.push('/login');
      this.$message.success('已退出登录');
      this.closeAllDropdowns();
    },
    goToPage(item) {
      this.$router.push(item.path);
      this.showMobileNav = false;
    },
    isNavItemActive(item) {
      if (item.path === '/science-extension') {
        return this.activeIndex.startsWith('/science-extension');
      }
      return this.activeIndex === item.path;
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 900;
      if (!this.isMobile) {
        this.showMobileNav = false;
      }
    },

    // ----- 用户下拉相关 -----
    toggleDesktopDropdown() {
      this.desktopDropdownVisible = !this.desktopDropdownVisible;
      if (this.desktopDropdownVisible) {
        this.$nextTick(() => this.updateDropdownPosition('desktop'));
      }
    },
    toggleMobileDropdown() {
      this.mobileDropdownVisible = !this.mobileDropdownVisible;
      if (this.mobileDropdownVisible) {
        this.$nextTick(() => this.updateDropdownPosition('mobile'));
      }
    },
    updateDropdownPosition(type) {
      let refName;
      if (type === 'desktop') refName = 'desktopUserWrapper';
      else if (type === 'mobile') refName = 'mobileUserWrapper';
      else if (type === 'science') refName = 'scienceWrapper';
      const trigger = this.$refs[refName];
      if (!trigger) return;
      const rect = trigger.getBoundingClientRect();
      const dropdownWidth = 200;
      if (type === 'desktop') {
        this.desktopDropdownStyle = {
          top: (rect.bottom + 6) + 'px',
          left: (rect.right - 220) + 'px'
        };
      } else if (type === 'mobile') {
        this.mobileDropdownStyle = {
          top: (rect.bottom + 6) + 'px',
          right: (window.innerWidth - rect.right) + 'px'
        };
      } else if (type === 'science') {
        this.scienceDropdownStyle = {
          top: (rect.bottom + 6) + 'px',
          left: Math.max(10, rect.left + (rect.width - dropdownWidth) / 2) + 'px'
        };
      }
    },
    goTo(path) {
      this.$router.push(path);
      this.closeAllDropdowns();
    },
    // 跳转到 Django 原生后台（独立于前端管理后台，需单独登录）
    openDjangoAdmin() {
      window.open('/admin', '_blank');
      this.closeAllDropdowns();
    },

    // ----- 科普拓展下拉 -----
    toggleScienceDropdown() {
      this.scienceDropdownVisible = !this.scienceDropdownVisible;
      if (this.scienceDropdownVisible) {
        this.$nextTick(() => this.updateDropdownPosition('science'));
      }
    },
    goToScience(path) {
      this.$router.push(path);
      this.scienceDropdownVisible = false;
    },

    closeAllDropdowns() {
      this.desktopDropdownVisible = false;
      this.mobileDropdownVisible = false;
      this.scienceDropdownVisible = false;
    },
    handleGlobalClick(e) {
      const desktopWrapper = this.$refs.desktopUserWrapper;
      const mobileWrapper = this.$refs.mobileUserWrapper;
      const scienceWrapper = this.$refs.scienceWrapper;
      if (desktopWrapper && !desktopWrapper.contains(e.target)) {
        this.desktopDropdownVisible = false;
      }
      if (mobileWrapper && !mobileWrapper.contains(e.target)) {
        this.mobileDropdownVisible = false;
      }
      if (scienceWrapper && !scienceWrapper.contains(e.target)) {
        this.scienceDropdownVisible = false;
      }
    },

    // ---------- 未读反馈提醒 ----------
    refreshUnread() {
      // 具体拉取逻辑在 store 里，这里只负责触发
      this.$store.dispatch('refreshNotify');
    },
    handleVisibilityChange() {
      // 从后台切回前台时立即刷一次，避免看到过期数字
      if (!document.hidden) this.refreshUnread();
    },
    startUnreadTimer() {
      this.stopUnreadTimer();
      // 60 秒轮询一次；页面不可见时直接跳过，不产生请求
      this.unreadTimer = setInterval(() => {
        if (document.hidden) return;
        this.refreshUnread();
      }, 60000);
    },
    stopUnreadTimer() {
      if (this.unreadTimer) {
        clearInterval(this.unreadTimer);
        this.unreadTimer = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// 全局变量
$primary-color: #409EFF;
$primary-light: rgba(64, 158, 255, 0.08);
$primary-dark: #337ecc;
$bg-white: #ffffff;
$text-primary: #303133;
$text-secondary: #606266;

/* 未读反馈徽标：包住头像，三个位置（桌面/移动端/抽屉）共用 */
.user-badge {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  line-height: 1;

  ::v-deep .el-badge__content {
    font-size: 11px;
    height: 16px;
    line-height: 16px;
    padding: 0 5px;
    border-radius: 8px;
    border: none;
    /* 白描边让徽标从头像上"浮"起来，圆头像上更干净 */
    box-shadow: 0 0 0 2px #fff;
  }
}

.nav-header {
  background: $bg-white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 64px;
  border-bottom: 1px solid #ebeef5;

  .nav-container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
  }

  // ========== 桌面端左侧Logo ==========
  .desktop-left-section {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }
  .desktop-logo {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: opacity 0.2s;
    &:hover {
      opacity: 0.85;
    }
    .logo-img {
      height: 38px;
      margin-right: 8px;
    }
    .brand-name {
      font-size: 18px;
      font-weight: 700;
      color: $text-primary;
      letter-spacing: 0.5px;
      white-space: nowrap;
    }
    .logo-subtitle {
      font-size: 11px;
      color: $text-secondary;
      margin-left: 8px;
      padding-left: 8px;
      border-left: 1px solid #dcdfe6;
      white-space: nowrap;
    }
  }

  // ========== 桌面端导航（自定义菜单项） ==========
  .desktop-nav {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: center;
    gap: 4px;

    .nav-item-custom {
      display: flex;
      align-items: center;
      padding: 0 12px;
      height: 60px;
      line-height: 59px;
      font-size: 14px;
      color: $text-secondary;
      cursor: pointer;
      transition: all 0.25s;
      border-bottom: 3px solid transparent;
      white-space: nowrap;

      i {
        margin-right: 4px;
        font-size: 15px;
      }
      &:hover {
        background-color: $primary-light;
        color: $primary-color;
      }
      &.is-active {
        color: $primary-color;
        font-weight: 600;
        border-bottom-color: $primary-color;
      }
    }

    .science-wrapper {
      position: relative;
      display: inline-flex;
      align-items: center;

      .science-trigger {
        .drop-arrow {
          margin-left: 4px;
          font-size: 11px;
          transition: transform 0.3s;
          &.rotate-up {
            transform: rotate(180deg);
          }
        }
      }
    }
  }

  // ========== 桌面端右侧用户区 ==========
  .desktop-right-section {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;

    .user-info-wrapper {
      position: relative;
      display: inline-block;
    }

    .user-info {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 5px 10px;
      border-radius: 34px;
      background: #f5f7fa;
      cursor: pointer;
      transition: all 0.25s;
      &:hover {
        background: $primary-light;
      }
      .user-avatar {
        border: 2px solid #e4e7ed;
      }
      .user-details {
        display: flex;
        flex-direction: column;
        .user-name {
          color: $text-primary;
          font-weight: 600;
          font-size: 13px;
          max-width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .user-role {
          color: $text-secondary;
          font-size: 10px;
        }
      }
      .el-icon-arrow-down {
        color: $text-secondary;
        font-size: 11px;
        transition: transform 0.3s;
        &.rotate-up {
          transform: rotate(180deg);
        }
      }
    }

    .login-btn {
      color: $primary-color;
      padding: 6px 12px;
      font-weight: 500;
      font-size: 14px;
      &:hover {
        background: $primary-light;
      }
    }
    .register-btn {
      background: $primary-color;
      border-color: $primary-color;
      color: #fff;
      font-weight: 500;
      font-size: 13px;
      padding: 8px 14px;
      &:hover {
        background: $primary-dark;
        border-color: $primary-dark;
      }
    }
  }

  // ========== 移动端导航栏 ==========
  .mobile-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .mobile-logo {
      display: flex;
      align-items: center;
      cursor: pointer;
      flex: 1;
      min-width: 0;
      .mobile-logo-img {
        height: 34px;
        margin-right: 8px;
        flex-shrink: 0;
      }
      span {
        font-size: 15px;
        font-weight: 700;
        color: $text-primary;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .mobile-actions {
      display: flex;
      align-items: center;
      gap: 12px;
      flex-shrink: 0;

      .mobile-user-wrapper {
        position: relative;
        display: inline-block;
      }

      .mobile-user-trigger {
        display: flex;
        align-items: center;
        gap: 3px;
        cursor: pointer;
        .mobile-avatar {
          border: 1.5px solid #e4e7ed;
        }
        .mobile-drop-arrow {
          font-size: 11px;
          color: $text-secondary;
          transition: transform 0.3s;
          &.rotate-up {
            transform: rotate(180deg);
          }
        }
      }

      .hamburger-menu {
        width: 24px;
        height: 17px;
        position: relative;
        cursor: pointer;
        z-index: 1010;
        span {
          position: absolute;
          width: 100%;
          height: 2.5px;
          background: $text-primary;
          border-radius: 2px;
          transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
          &:nth-child(1) {
            top: 0;
            transform-origin: left center;
          }
          &:nth-child(2) {
            top: 50%;
            transform: translateY(-50%);
          }
          &:nth-child(3) {
            bottom: 0;
            transform-origin: left center;
          }
        }
        &.active {
          span:nth-child(1) {
            transform: rotate(45deg) translate(3px, -3px);
            width: 25px;
          }
          span:nth-child(2) {
            opacity: 0;
          }
          span:nth-child(3) {
            transform: rotate(-45deg) translate(3px, 3px);
            width: 25px;
          }
        }
      }
    }
  }

  // ========== 移动端抽屉 ==========
  .mobile-nav-drawer {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 998;
    .nav-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.35);
    }
    .nav-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 82%;
      max-width: 340px;
      height: 100vh;
      background: #fff;
      box-shadow: 4px 0 20px rgba(0, 0, 0, 0.08);
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      .mobile-user-info {
        background: linear-gradient(135deg, #e8f4ff 0%, #d9ecff 100%);
        padding: 28px 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .user-avatar-large {
          border: 3px solid rgba($primary-color, 0.2);
        }
        .user-details {
          margin-left: 15px;
          flex: 1;
          h3 {
            font-size: 17px;
            color: $text-primary;
            margin-bottom: 4px;
          }
          .user-role-tag {
            display: inline-block;
            background: rgba($primary-color, 0.1);
            color: $primary-color;
            padding: 2px 10px;
            border-radius: 10px;
            font-size: 12px;
          }
        }
        .arrow-icon {
          color: $text-secondary;
          font-size: 16px;
        }
      }
      .mobile-login-prompt {
        background: linear-gradient(135deg, #e8f4ff 0%, #d9ecff 100%);
        padding: 24px 20px;
        p {
          margin-bottom: 14px;
          font-size: 15px;
          color: $text-primary;
        }
        .login-buttons {
          display: flex;
          gap: 12px;
          .mobile-login-btn {
            color: $primary-color;
            &:hover {
              background: rgba($primary-color, 0.08);
            }
          }
        }
      }
      .nav-list,
      .feature-list {
        padding: 16px 0;
        border-bottom: 1px solid #ebeef5;
        .nav-item {
          display: flex;
          align-items: center;
          padding: 14px 20px;
          color: $text-primary;
          cursor: pointer;
          transition: all 0.2s;
          &:hover {
            background: #f5f7fa;
            padding-left: 24px;
          }
          &.active {
            background: $primary-light;
            color: $primary-color;
            border-left: 4px solid $primary-color;
            .nav-item-icon {
              background: rgba($primary-color, 0.15);
            }
          }
          .nav-item-icon {
            width: 36px;
            height: 36px;
            border-radius: 8px;
            background: #f0f2f5;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 14px;
            i {
              font-size: 18px;
              color: inherit;
            }
          }
          .nav-item-title {
            flex: 1;
            font-size: 15px;
            font-weight: 500;
          }
          .active-check {
            color: $primary-color;
            font-size: 16px;
          }
        }
      }
      .logout-btn {
        display: flex;
        align-items: center;
        padding: 18px 20px;
        color: #f56c6c;
        cursor: pointer;
        transition: all 0.2s;
        margin-top: auto;
        &:hover {
          background: #fef0f0;
          padding-left: 24px;
        }
        i {
          font-size: 18px;
          width: 22px;
          margin-right: 12px;
        }
        span {
          font-size: 15px;
          font-weight: 500;
        }
      }
      .nav-footer {
        padding: 18px;
        text-align: center;
        border-top: 1px solid #ebeef5;
        color: #909399;
        font-size: 12px;
        p {
          margin: 3px 0;
        }
        .version {
          font-size: 11px;
          opacity: 0.6;
        }
      }
    }
  }
}

// ========== 抽屉动画 ==========
.nav-slide-enter-active,
.nav-slide-leave-active {
  transition: opacity 0.25s ease;
  .nav-content {
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }
}
.nav-slide-enter,
.nav-slide-leave-to {
  opacity: 0;
  .nav-content {
    transform: translateX(-100%);
  }
}

// ========== 响应式微调 ==========
@media (max-width: 1100px) {
  .desktop-logo .logo-subtitle {
    display: none;
  }
  .desktop-nav .nav-item-custom {
    padding: 0 10px;
    font-size: 13px;
    i {
      margin-right: 3px;
      font-size: 14px;
    }
  }
}
@media (max-width: 960px) {
  .desktop-nav .nav-item-custom {
    padding: 0 7px;
    font-size: 12px;
  }
  .nav-header .nav-container {
    padding: 0 12px;
  }
}
@media (max-width: 900px) {
  .nav-header .nav-container {
    padding: 0 14px;
  }
}
</style>

<!-- 全局自定义下拉菜单样式（非 scoped） -->
<style lang="scss">
.custom-dropdown {
  position: fixed !important;
  width: 210px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid #ebeef5;
  padding: 8px 0;
  z-index: 9999;
  transform-origin: top center;
  animation: dropdownFade 0.2s ease;
  max-height: calc(100vh - 120px);
  overflow-y: auto;

  .custom-dropdown-item {
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #303133;
    font-size: 14px;
    cursor: pointer;
    transition: background 0.2s;
    &:hover {
      background: #f5f7fa;
    }
    i {
      font-size: 16px;
      color: #606266;
      width: 18px;
    }
    /* 下拉菜单里的未读数字，靠右对齐 */
    .menu-count {
      margin-left: auto;
      min-width: 18px;
      height: 18px;
      padding: 0 5px;
      box-sizing: border-box;
      border-radius: 9px;
      background: #f56c6c;
      color: #fff;
      font-size: 11px;
      line-height: 18px;
      text-align: center;
    }
    &.logout-item {
      color: #f56c6c;
      i {
        color: #f56c6c;
      }
      &:hover {
        background: #fef0f0;
      }
    }
  }
  .custom-dropdown-divider {
    height: 1px;
    background: #ebeef5;
    margin: 4px 0;
  }
}

@keyframes dropdownFade {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>